<template>
<div class="vcr-image">
  <gkAdEvent :src="ad.src" :idea="ad" :scale="50" />
  <p>
    {{ad.desc}}
    <br />
    <gkAdEvent tag="a" type="text" :idea="ad" :trigger="['click']">
      立即围观 &gt;&gt;
      <!-- <i class="iconfont">&#xe62f;</i> -->
    </gkAdEvent>
  </p>
</div>
</template>

<script>
import VueTypes from 'vue-types'
import gkAdEvent from 'gkui/ad/ADEvent'

/**
 * 标题广告 - VCRBox
 * @desc VCRBox 中纯标题的广告展示模块
 * @module component/VCRBox
 * @extends ADEvent
 */
export default {
  name: 'vcrbox-list-image',
  /**
   * 引用的组件
   * @prop {Component}  gkAdEvent  广告组件
   */
  components: {
    gkAdEvent
  },
  /**
   * 传入数据
   */
  props: {
    ad: VueTypes.shape({
      desc: VueTypes.string.def(''),
      src: String,
      route: String,
      visible: String,
      click: String
    }).loose
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.vcr-image {
  padding: 20px 0 5px; margin-top: -1px;
  border-top: 1px solid $borderGray; border-bottom: 1px solid $borderGray;
  cursor: default;

  &:first-child {
    padding: 12px 0 5px;
    border-top: none;
  }
  &:last-child {
    border-bottom: none;
  }

  & ::v-deep img {
    box-sizing: border-box;
    border: 1px solid #F0F1F3; border-radius: 4px;
  }

  & p {
    padding-top: 6px;
    line-height: 24px;
    text-align: justify;
    @include font(14, 400);
    color: $lightBlack;

  }

  & .iconfont {
    position: relative; top: -1px; left: -2px;
    @include font(12, 400);
  }

  & a {
    color: $blue;
  }
}
@media screen and (max-width: 768px) {
  .vcr-image {
    padding: 24px 0 5px;

    &:first-child {
      padding: 10px 0 5px;
    }

    & ::v-deep img {
      box-sizing: border-box;
      border: 1px solid #F0F1F3; border-radius: 4px;
    }

    & p {
      padding-top: 8px;
      line-height: 24px;
      @include font(16, 400);
    }
  }
}
</style>
